import { normalizePhoneForOtp } from "../Redux/thunks/contactOtpThunks";

/**
 * Build OTP verification steps for changed phone/email fields.
 * Returns an array of { channel, value } objects in verification order.
 */
export function buildContactOtpSteps(initialState, formData) {
  const steps = [];

  if (initialState.phone !== formData.phone) {
    steps.push({
      channel: "phone",
      value: normalizePhoneForOtp(formData.phone),
    });
  }

  if (initialState.email !== formData.email) {
    steps.push({
      channel: "email",
      value: String(formData.email).trim(),
    });
  }

  return steps;
}

export function contactFieldsChanged(initialState, formData) {
  return (
    initialState.phone !== formData.phone ||
    initialState.email !== formData.email
  );
}
